import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import urlMapping from '../../app/URLMapping';
import {FullScreenPanel} from '../EmbededPanel.react';
import {lastPanelController} from '../EmbededPanelController';
import {FormattedMessage} from 'react-intl';
import LoadingButton from '../../fw/LoadingButton.react';
import {wrapNotFound} from '../../app/NotFoundHandler.react';
import * as BrowserPermission from "../../BrowserPermission";
import types from '../../../common/model-api/types';
import {getLastOrganisationId} from '../../app/LastOrganisationId';

class CreateScreenStep1 extends React.Component {

    static propTypes = {
        user: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
    }

    static contextTypes = {
        embededPanelController: PropTypes.object,
        router: PropTypes.object,
        screenInfo: PropTypes.object,
        screenOperation: PropTypes.string,
    };

    createScreen = () => {
        let path = urlMapping.getUrl("panel", "create-screen-step-2", lastPanelController().getURLObject());
        this.context.router.push(path);
    };

    close = () => {
        let path = urlMapping.getUrl("panel", "no-screen", lastPanelController().getURLObject());
        this.context.router.push(path);
    };

    render() {
        let type = types['screens'];
        let channel = this.props.user.organisation.channel;

        return (
            <FullScreenPanel close={this.close} showBackToPanel>
                <div className="bordered-content">
                    <h2><FormattedMessage defaultMessage="Screen Settings" id="screen.create.title" /></h2>

                    <p><FormattedMessage defaultMessage="Screen shows you all the important information you want to see." id="screen.create.description" /></p>

                    {type.canCreate(BrowserPermission.getPermissionObject(), channel, this.props.user.organisation.realId) && type.canUserCreate() ?
                        <LoadingButton className="btn btn-primary" onClick={this.createScreen}><FormattedMessage defaultMessage="Create Screen" id="screen.create.action" /></LoadingButton>
                        :
                        <LoadingButton className="btn btn-primary" disabled><FormattedMessage defaultMessage="You are not allowed to create screen" id="screen.create.noPermission" /></LoadingButton>
                    }

                </div>
            </FullScreenPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(CreateScreenStep1, (props) => {
    return props.user.organisation && props.user.organisation.channel;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => {
            return Relay.QL`
                fragment on User {
                    id,
                    organisation(id: $organisationId) {
                        id,
                        realId,
                        channel(id: $channelId) {
                            id,
                            realId,
                            channelDef {
                                id,
                                realId,
                                name,
                                icon,
                            }
                        }
                    }
                }`;
        }
    },


});
